<template>
  <ModalLayout
    v-if="isVisible"
    @close="beginClose"
    @closed="finalClose"
    maxSize="max-w-[340px] sm:max-w-sm md:max-w-3xl"
  >
    <template #body>
      <div class="p-6 space-y-4">
        <h2 class="text-2xl font-bold">{{ project.title }}</h2>
        <p class="text-gray-600">{{ project.description }}</p>

        <!-- Media viewer -->
        <div v-if="project.videoUrl">
          <video controls class="w-full rounded-lg shadow">
            <source :src="project.videoUrl" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
        <div v-else-if="project.imageUrl">
          <img :src="project.imageUrl" :alt="project.title" class="w-full rounded-lg shadow" />
        </div>

        <!-- Tech tags -->
        <div class="flex flex-wrap gap-2 mt-4">
          <span
            v-for="(item, index) in project.tech"
            :key="index"
            class="text-xs bg-gray-100 text-gray-700 px-2 py-1 rounded-full"
          >
            {{ item }}
          </span>
        </div>
      </div>
    </template>
  </ModalLayout>
</template>

<script>
import ModalLayout from '@/layouts/ModalLayout.vue';

export default {
  name: 'ProjectViewModal',
  components: {
    ModalLayout,
  },
  props: {
    project: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isVisible: true,
    };
  },
  methods: {
    beginClose() {
      this.isVisible = false; // triggers exit animation in ModalLayout
    },
    finalClose() {
      this.$emit('close'); // fully unmount after animation completes
    },
  },
};
</script>
